module.exports = __webpack_public_path__ + "static/media/artist_ehy-x_b.368dfefe.png";